import React, { Component } from 'react';
import _ from 'lib/lodash'

import VideoCardList from 'components/cards/video/v1/VideoCardList'
import ImageCardList from 'components/cards/image/v1/ImageCardList'
import DocumentCardList from 'components/cards/document/v1/DocumentCardList'
import ContactCardList from 'components/cards/contact/v1/ContactCardList'
import FeedbackCardList from 'components/cards/feedback/default/FeedbackCardList'
import LinkCardList from 'components/cards/link/v1/LinkCardList'

import Actions from './BundleActions'

import 'components/cards/Cards.css'
//import LinkCardItem from "../../cards/link/v1/LinkCardItem";

class BundleBody extends Component {

	render() {
		const { payload, actionHandler } = this.props;
		const { nodes } = payload;
		const { nodeHandler } = actionHandler;
		const { isUploading } = nodeHandler;

		return (
			<div className="bundle-cards">
				{ !isUploading && <Actions actionHandler={actionHandler}/> }
				<ImageCardList
					payload={payload}
					nodes={_.get(nodes, 'image')}
					actionHandler={actionHandler}
					aclAllow={{create: "bundle-image-create", edit: "bundle-image-edit"}}
				/>
				<VideoCardList
					payload={payload}
					nodes={_.get(nodes, 'video')}
					actionHandler={actionHandler}
					aclAllow={{create: "bundle-video-create", edit: "bundle-video-edit"}}
				/>
				<DocumentCardList
					payload={payload}
					nodes={_.get(nodes, 'document')}
					actionHandler={actionHandler}
					aclAllow={{create: "bundle-video-create", edit: "bundle-video-edit"}}
				/>
				<LinkCardList
					payload={payload}
					nodes={_.get(nodes, 'link')}
					actionHandler={actionHandler}
					aclAllow={{create: "bundle-link-create", edit: "bundle-link-edit"}}
				/>
				<FeedbackCardList
					payload={payload}
					nodes={_.get(nodes, 'feedback')}
					actionHandler={actionHandler}
					aclAllow={{create: "bundle-feedback-create", edit: "bundle-feedback-edit"}}
				/>
				<ContactCardList
					payload={payload}
					nodes={_.get(nodes, 'contact')}
					actionHandler={actionHandler}
					aclAllow={{create: "bundle-contact-create", edit: "bundle-contact-edit"}}
				/>
			</div>
		);
	}
}

export default BundleBody;



// WEBPACK FOOTER //
// ./src/components/bundle/v1/BundleBody.jsx